import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide loader after 2 seconds
setTimeout(() => {
  document.getElementById("loader").style.display = "none";
}, 2000);
